import hooks from '../../../hooks'
import { useQuery } from 'react-query'

const useReflectionPrompt = ({
    id
}) => {

    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url, time } = hooks.useApi()

    const { data, isLoading } = useQuery(
        [cacheKeys.REFLECTION_PROMPTS, id],
        () => api.get(url(endpoints.reflectionPrompt, { promptId: id })),
        {
            staleTime: time.MINUTE * 5,
            enabled: Boolean(id)
        }
    )

    return {
        reflectionPrompt: data || {},
        isLoadingReflectionPrompt: isLoading
    }
}

export default useReflectionPrompt
